import { render, staticRenderFns } from "./CreateUser.vue?vue&type=template&id=3653d8e4&scoped=true"
import script from "./CreateUser.vue?vue&type=script&lang=js"
export * from "./CreateUser.vue?vue&type=script&lang=js"
import style0 from "./CreateUser.vue?vue&type=style&index=0&id=3653d8e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3653d8e4",
  null
  
)

export default component.exports